/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
==========================================================================================*/

export default [
  // {
  //   url: "/apps/email",
  //   name: "Email",
  //   slug: "email",
  //   icon: "MailIcon",
  //   i18n: "Email",
  // },
  {
    url: null,
    name: 'Home',
    tagColor: 'primary',
    icon: 'HomeIcon',
    i18n: 'Home',
    submenu: [
      {
        name: 'Dashboard',
        i18n: 'Dashboard',
        url: '/dashboard/analytics',
        slug: 'dashboard',
      },
      /*{
        name: 'Calendar',
        i18n: 'Calendar',
        url: '/calendar',
        slug: 'calandar',
      },*/
      {
        name: 'Calendar',
        i18n: 'Calendar',
        url: '/calendarv2',
        slug: 'calandar',
        tagColor:'#c0c0c0'
      }
    ]
  },
  {
    header: 'People',
    icon: 'LayersIcon',
    i18n: 'People',
    items: [
      {
        url: null,
        name: 'Contacts',
        tagColor: 'primary',
        icon: 'UsersIcon',
        i18n: 'Contacts',
        url: '/people/people-list'
      },

      {
        url: null,
        name: 'Employees',
        tagColor: 'primary',
        icon: 'UserIcon',
        i18n: 'Employees',
        submenu: [
          {
            name: 'Employees List',
            i18n: 'Employees List',
            url: '/employees/employees-list',
            slug: 'Employees List',
          },
          {
            name: 'XYLO PTJ',
            i18n: 'XYLO PTJ',
            url: '/attendance-sso',
            slug: 'Attendance & Usage',
          },
        ]
      }
    ]
  },
  {
    header: 'Sales',
    icon: 'LayersIcon',
    i18n: 'Sales',
    items: [

      {
        url: null,
        name: 'Quotation',
        tagColor: 'primary',
        icon: 'DollarSignIcon',
        i18n: 'Quotations',
        submenu: [
          {
            name: 'List',
            icon: 'ActivityIcon',
            url: '/quotation/quotation-list' ,
            slug: 'Quotations',
          },
          {
            name: 'Overdue',
            icon: 'ActivityIcon',
            url: '/dashboard/quotation',
            slug: 'Quotation',
          },
        ]
      },
      {
        url: null,
        tagColor: 'primary',
        icon: 'UploadIcon',
        name: 'Invoices',
        slug: 'Invoices',
        i18n: 'Invoices',
        submenu: [
          {
            name: 'List',
            icon: 'ActivityIcon',
            url: '/invoice/invoice-list',
            slug: 'Invoices',
          },
          {
            name: 'Firewood',
            icon: 'FileTextIcon',
            url: '/invoice/firewood-list',
            slug: 'Firewood',
          },
          {
            name: 'Overdue',
            icon: 'ActivityIcon',
            url: '/dashboard/finance',
            slug: 'Overdue',
          },
        ]
      },
      {
        url: '/efacturalist-out',
        tagColor: 'primary',
        icon: 'GlobeIcon',
        name: 'eFactura',
        slug: 'eFactura',
        i18n: 'eFactura',
      }
    ]
  },
  {
    header: 'Purchases',
    icon: 'LayersIcon',
    i18n: 'Purchases',
    items: [
      {
        url: null,
        name: 'Purchase',
        tagColor: 'primary',
        icon: 'ShoppingCartIcon',
        i18n: 'Purchase Orders',
        url: '/purchase/purchase-list'
      },
      {
        url: null,
        tagColor: 'primary',
        icon: 'DownloadIcon',
        url: '/reception/reception-list',
        name: 'Receptions',
        slug: 'receptions',
        i18n: 'Receptions'
      },
      {
        url: null,
        name: 'Expenses',
        tagColor: 'primary',
        icon: 'ShoppingBagIcon',
        i18n: 'Expenses',
        submenu: [
          {
            url: '/efacturalist-in',
            tagColor: 'primary',
            icon: 'ShoppingBagIcon',
            name: 'eFactura Pending',
            slug: 'eFactura Pending',
            i18n: 'eFactura Pending',
          },
          {
            url: '/efacturalist-ing',
            tagColor: 'primary',
            icon: 'ShoppingBagIcon',
            name: 'eFactura List',
            slug: 'eFactura List',
            i18n: 'eFactura List',
          }
        ]
      },
    ]
  },
  {
    header: 'Operations',
    icon: 'LayersIcon',
    i18n: 'Operation',
    items: [
      {
        url: '/scale/pesees',
        tagColor: 'primary',
        icon: 'BarChart2Icon',
        name: 'Weighings',
        slug: 'scale-pesees',
        i18n: 'Weighings'
      },
      {
        url: null,
        tagColor: 'primary',
        icon: 'ZapIcon',
        url: '/production/production-list',
        name: 'Production',
        slug: 'production',
        i18n: 'Production'
      },
      {
        url: null,
        name: 'Transport',
        tagColor: 'primary',
        icon: 'TruckIcon',
        i18n: 'Transport',
        submenu: [
          {
            name: 'Dashboard',
            icon: 'ActivityIcon',
            url: '/dashboard/transport',
            slug: 'Dashboard',
          },
          {
            url: null,
            tagColor: 'primary',
            icon: 'TruckIcon',
            url: '/transport/transport-list',
            name: 'List',
            slug: 'List',
            i18n: 'List'
          },
          {
            url: '/etransport/list',
            tagColor: 'primary',
            icon: 'ShoppingBagIcon',
            name: 'eTransport',
            slug: 'eTransport',
            i18n: 'eTransport'
          }
        ]
      },
      // Harvesting 2.0 remplace l'ancien tableau de bord /dashboard/harvesting
      // (désactivé : la route redirige ici). Sorti de la Restricted Area le 2026-10-27.
      {
        name: 'Harvesting 2.0',
        icon: 'ScissorsIcon',
        url: '/harvesting2',
        slug: 'harvesting2',
        tagColor:'#c0c0c0'
      },
    ]
  },
  {
    header: 'Stock',
    icon: 'LayersIcon',
    i18n: 'Stock',
    items: [
      {
        url: '/stock/stock-list',
        name: 'Stock',
        tagColor: 'primary',
        icon: 'PackageIcon',
        i18n: 'Stock',
      },
      {
        url: '/stock/alert',
        name: 'StockAlert',
        tagColor: 'primary',
        icon: 'AlertTriangleIcon',
        i18n: 'Stock Alert',
      },
      {
        url: '/woodfinder',
        name: 'Wood Finder',
        tagColor: 'primary',
        icon: 'SearchIcon',
        i18n: 'Wood Finder',
      },
      {
        url: '/customerfinder',
        name: 'Customer Finder',
        tagColor: 'primary',
        icon: 'TargetIcon',
        i18n: 'Customer Finder',
      },
      {
        url: '/stock/fsc',
        name: 'FSC',
        tagColor: 'primary',
        icon: 'AwardIcon',
        i18n: 'FSC',
      },
    ],
  }
]

